import request from "../../utils/api";
import moment from "moment";

export const getUnitDetails = params => {
  const { projectId, unitId } = params;
  const url = `v1/sellers/properties/${projectId}/units/${unitId}`;

  return request(url, {
    params
  });
};

export const getPaymentSchemes = params => {
  const { projectId, unitId, buildingCode, brand } = params;

  console.log(params);

  return request(
    `v1/sellers/${brand}/properties/${projectId}/buildings/${buildingCode}/units/${unitId}/schemes`,
    // `v1/sellers/${projectId}/buildings/${buildingCode}/units/${unitId}/schemes`,
    {}
  );
};

export const numberFormat = value => {
  value = parseFloat(value);
  return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$&,");
};

const createData = (
  payment,
  today,
  currentIndex,
  amount,
  months,
  closingFees,
  followingDay,
  currency,
  exchangeRate,
  closingFeeScheme,
  additionalMonth
) => {
  let data = [];

  if (payment === "SPOT" && months > 0) {
    const spotDays = months * 30;
    let newIndex = data.length + currentIndex;
    // const additionalMonth = followingDay === 1 ? 2 : 1;

    const spot = {
      key: newIndex,
      // date: today
      //   .add(spotDays, "days")
      //   // .add(newIndex > 1 ? 1 : 2, "months")
      //   .format("DD-MMM-YY"),
      date: today.add(spotDays, "days").format("DD-MMM-YY"),
      payment: months <= 1 ? payment : `${payment}`,
      unit: numberFormat(amount),
      closing_fees: numberFormat(closingFees),
      total: numberFormat(amount + closingFees),
      foreign_total: `${currency} ${numberFormat(
        (amount + closingFees) / exchangeRate
      )}`
    };

    data.push(spot);

    return data;
  }

  if (payment === "BALANCE" && months > 0) {
    // const balanceDays = months * 30;
    let newIndex = data.length + currentIndex;

    const balance = {
      key: newIndex,
      // date: today
      //   .add(spotDays, "days")
      //   // .add(newIndex > 1 ? 1 : 2, "months")
      //   .format("DD-MMM-YY"),
      date: today.add(months, "months").format("DD-MMM-YY"),
      payment: months <= 1 ? payment : `${payment}`,
      unit: numberFormat(amount),
      closing_fees: numberFormat(closingFees),
      total: numberFormat(amount + closingFees),
      foreign_total: `${currency} ${numberFormat(
        (amount + closingFees) / exchangeRate
      )}`
    };

    data.push(balance);

    return data;
  }

  for (let key = 1; key <= months; key++) {
    const amt = amount / months;
    let newIndex = data.length + currentIndex;

    let closing = closingFees;
    if (payment === "MA") {
      if (closingFeeScheme !== "installment") {
        if (key === months) {
          closing = closingFees * months;
        } else {
          closing = 0;
        }
      }
    }

    if (key > 1) {
      additionalMonth = 1;
    }

    // console.log("payment", payment);
    // console.log(closingFeeScheme);
    // console.log("key", key);

    const spot = {
      key: newIndex,
      date: today
        .add(additionalMonth, "months")
        .date(followingDay)
        .format("DD-MMM-YY"),
      payment: months <= 1 ? payment : `${payment}${key}`,
      unit: numberFormat(amt),
      closing_fees: numberFormat(closing),
      total: numberFormat(amt + closing),
      foreign_total: `${currency} ${numberFormat(
        (amt + closingFees) / exchangeRate
      )}`
    };

    data.push(spot);
  }

  return data;
};

export const mortgageCalculation = params => {
  const {
    scheme,
    netPrice,
    reservationFee,
    selectedCloseFeeScheme,
    closingFee,
    currency,
    exchangeRate
  } = params;

  // console.log("params", params);

  const paymentScheme = scheme.split("/");
  const spotScheme = paymentScheme[0].replace(")", "").split("(");
  const amortizationScheme = paymentScheme[1].replace(")", "").split("(");
  const balanceScheme = paymentScheme[2].replace(")", "").split("(");

  // Prices
  const totalPrice = netPrice;
  const spotAmount =
    totalPrice * (parseInt(spotScheme[0]) / 100) - reservationFee;

  const spotMonths = parseInt(spotScheme[1]);

  let amortizationAmount =
    totalPrice * (parseInt(amortizationScheme[0]) / 100) - reservationFee;

  if (spotAmount > 0) {
    amortizationAmount = totalPrice * (parseInt(amortizationScheme[0]) / 100);
  }

  const amortizationMonths = parseInt(amortizationScheme[1]);

  const balanceAmount = totalPrice * (parseInt(balanceScheme[0]) / 100);
  const balanceMonths = parseInt(balanceScheme[1]);

  // const monthly = netPrice / 13 - reservationFee;

  // Closing fee calculation
  let closingFeeSpot = 0;
  let closingFeeAmort = 0;
  let closingFeeBalance = 0;

  let closingFeeMonths =
    (spotMonths > 0 ? 1 : 0) + amortizationMonths + balanceMonths + 1;
  let closingFees = Array(closingFeeMonths).fill(0);
  switch (selectedCloseFeeScheme) {
    case "installment":
      // let monthlyClosing = closingFee / (closingFeeMonths - 1);

      if (amortizationMonths > 0) {
        // closingFeeSpot = closingFee * (parseInt(spotScheme[0]) / 100);
        // closingFeeBalance = closingFee * (parseInt(balanceScheme[0]) / 100);
        closingFeeAmort = closingFee / amortizationScheme[1];
      } else {
        closingFeeSpot = closingFee;
        // closingFeeBalance = closingFee * (parseInt(balanceScheme[0]) / 100);
        // closingFeeAmort =
        //   (closingFee * (parseInt(amortizationScheme[0]) / 100)) /
        //   amortizationScheme[1];
      }

      // console.log("cfs", closingFeeSpot);
      // console.log("cfa", closingFeeAmort);
      // console.log("cfb", closingFeeBalance);
      break;
    default:
      if (amortizationMonths > 0) {
        closingFeeAmort = closingFee / amortizationScheme[1];
      } else {
        closingFeeSpot = closingFee;
      }
  }

  const today = moment();
  const rfDate = moment();
  let followingDay = today.get("date") >= 16 ? 1 : 16; // if date today is gte 16, then followingday should be 1
  let additionalMonth = followingDay === 1 ? 2 : 1; // if following day is 1, then add 2 months, else 1

  // Create data
  let schemeData = [
    {
      key: 0,
      date: today.format("DD-MMM-YY"),
      payment: "RF",
      unit: numberFormat(reservationFee),
      closing_fees: numberFormat(closingFees[0]),
      total: numberFormat(reservationFee),
      foreign_total: `${currency} ${numberFormat(
        reservationFee / exchangeRate
      )}`
    }
  ];

  // Create spot data
  const spots = createData(
    "SPOT",
    today,
    schemeData.length,
    spotAmount,
    spotMonths,
    closingFeeSpot,
    followingDay,
    currency,
    exchangeRate,
    selectedCloseFeeScheme,
    0
  );
  schemeData = schemeData.concat(spots);

  // if the spot month is more than 0,
  if (spotMonths > 0) {
    additionalMonth = 1;
  }

  if (amortizationMonths === 0) {
    followingDay = Math.abs(Math.abs(today.get("date") - 30) - 30);
  }

  const amortizations = createData(
    "MA",
    today,
    schemeData.length,
    amortizationAmount,
    amortizationMonths,
    closingFeeAmort,
    followingDay,
    currency,
    exchangeRate,
    selectedCloseFeeScheme,
    additionalMonth
  );
  schemeData = schemeData.concat(amortizations);

  if (selectedCloseFeeScheme !== "installment") {
    // schemeData[schemeData.length - 1].closing_fees = numberFormat(closingFee);
    // schemeData[schemeData.length - 1].total = schemeData[schemeData.length - 1].total + closingFee
  }

  if (amortizationMonths === 0) {
    followingDay = Math.abs(Math.abs(today.get("date") - 30) - 30);
  }

  let balanceStart = today;
  let balanceMonthsCopy = balanceMonths;
  if (spotMonths > 0) {
    if (balanceMonths > 0) {
      // balanceMonthsCopy = balanceMonths - 1;
    }

    balanceStart = rfDate;
  }

  const balances = createData(
    "BALANCE",
    balanceStart,
    schemeData.length,
    balanceAmount,
    balanceMonthsCopy,
    closingFeeBalance,
    followingDay,
    currency,
    exchangeRate,
    selectedCloseFeeScheme,
    1
  );
  schemeData = schemeData.concat(balances);

  // if (selectedCloseFeeScheme !== "installment") {
  // schemeData[schemeData.length - 1].closing_fees = numberFormat(closingFee);
  // }

  return {
    schemeData,
    spotScheme,
    spotMonths: isNaN(spotMonths) ? 0 : spotMonths,
    amortizationScheme,
    amortizationMonths: isNaN(amortizationMonths) ? 0 : amortizationMonths,
    balanceScheme,
    balanceMonths: isNaN(balanceMonths) ? 0 : balanceMonths
  };
};
